"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _useFieldContext = _interopRequireDefault(require("../../../../hooks/useFieldContext"));
var FSTypes = _interopRequireWildcard(require("../../../../types"));
var _sprintf = _interopRequireDefault(require("../../../../../../utils/sprintf"));
var _react = require("react");
var _server = require("react-dom/server");
var _uuid = require("uuid");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var validationName = "loading";
var Loading = function Loading(props) {
  var children = props.children,
    _a = props.condition,
    condition = _a === void 0 ? true : _a,
    i18n = props.i18n;
  var uuid = (0, _react.useState)((0, _uuid.v4)())[0];
  var _b = (0, _useFieldContext.default)(),
    addValidation = _b.addValidation,
    removeValidation = _b.removeValidation,
    label = _b.label;
  var validation = (0, _react.useCallback)(function (value, fieldName) {
    if (!condition) {
      return [];
    }
    return [{
      fieldName: fieldName,
      type: FSTypes.ValidationTypes.Loading,
      text: children !== undefined ? (0, _server.renderToString)((0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: children
      })) : (0, _sprintf.default)((i18n === null || i18n === void 0 ? void 0 : i18n.text) || "", {
        value: String(value),
        fieldName: fieldName,
        label: String(label)
      })
    }];
  }, [children, condition, i18n === null || i18n === void 0 ? void 0 : i18n.text, label]);
  (0, _react.useEffect)(function () {
    if (condition) {
      addValidation("".concat(validationName, "_").concat(uuid), validation);
    } else {
      removeValidation("".concat(validationName, "_").concat(uuid));
    }
    return function () {
      removeValidation("".concat(validationName, "_").concat(uuid));
    };
  }, [addValidation, condition, removeValidation, uuid, validation]);
  return null;
};
var _default = Loading;
exports.default = _default;